<script lang="ts">
  type Status = "planning" | "active" | "completed" | "cancelled" | "draft" | "published";

  let {
    status,
    size = "sm",
  }: {
    status: Status;
    size?: "sm" | "md";
  } = $props();

  const config: Record<Status, { label: string; color: string; bg: string }> = {
    planning: { label: "계획 중", color: "text-blue-400", bg: "bg-blue-500/12" },
    active:   { label: "여행 중", color: "text-green-400", bg: "bg-green-500/12" },
    completed:{ label: "완료",   color: "text-gray-400",  bg: "bg-white/8" },
    cancelled:{ label: "취소",   color: "text-red-400",   bg: "bg-red-500/12" },
    draft:    { label: "초안",   color: "text-amber-400", bg: "bg-amber-500/12" },
    published:{ label: "발행됨", color: "text-teal-400",  bg: "bg-teal-500/12" },
  };

  const c = $derived(config[status] ?? config.planning);
  const sizeClass = $derived(size === "md" ? "px-3 py-1 text-sm" : "px-2 py-0.5 text-xs");
</script>

<span class="inline-flex items-center gap-1 rounded-full font-medium {sizeClass} {c.color} {c.bg}">
  <span class="w-1.5 h-1.5 rounded-full bg-current opacity-70"></span>
  {c.label}
</span>
